import { render } from "./Sleep.vue?vue&type=template&id=3ffa8246&scoped=true"
import script from "./Sleep.vue?vue&type=script&lang=js"
export * from "./Sleep.vue?vue&type=script&lang=js"

import "./Sleep.vue?vue&type=style&index=0&id=3ffa8246&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffa8246"]])

export default __exports__